import Axios from 'axios'
import { Message } from 'element-ui'
import router from '../router'

const instance = Axios.create({
    baseURL: 'https://gwapi.jinyunai.com',   //正式地址
    // baseURL: 'https://test.newcoc.cn',   //正式地址
    timeout: 20000
})

export default function http(url, data, method, params) {
    return instance({
        url,
        data,
        method,
        params
    }).then(res => {
        // console.log(res)
        return res
    }).catch(err => {
      console.log(err)
    })
}



// WEBPACK FOOTER //
// ./src/config/index.js